import {
  type UserDisplayModelComputedProperties,
  UserDisplayModelSchema,
  toUserDisplayModel,
} from '@mntn-dev/domain-types'
import type { SetOptional } from 'type-fest'
import { z } from 'zod'

export const PersonSchema = UserDisplayModelSchema.extend({
  avatarUrl: z.string().optional(),
})

export type Person = z.infer<typeof PersonSchema>

export const toPerson = ({
  avatarUrl,
  ...person
}: SetOptional<Person, UserDisplayModelComputedProperties>) =>
  <const>{
    ...toUserDisplayModel(person),
    avatarUrl,
  }
